import { TransmissionSchedule } from "../TransmissionSchedule";
import { Checkbox, DataSource, Image, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiEventStatusTableEdit extends Layout {
    checkboxApptConfirmed: Checkbox;
    checkboxCommentsToStop: Checkbox;
    checkboxCreateServiceIncident: Checkbox;
    checkboxDepartCanArrive: Checkbox;
    checkboxPickupPosPrevDelivered: Checkbox;
    checkboxResendEarReqSrc: Checkbox;
    checkboxResendIfEarly: Checkbox;
    checkboxResendIfLate: Checkbox;
    checkboxResendLatReqSrc: Checkbox;
    checkboxShowOnReport: Checkbox;
    checkboxUpdateAppt: Checkbox;
    checkboxUpdateStopPieces: Checkbox;
    checkboxUpdateStopWeight: Checkbox;
    imagePickupInfo: Image;
    imageResendOptions: Image;
    labelDepartureLabel: Label;
    labelDriverCallins: Label;
    labelFirstText: Label;
    labelGeneral: Label;
    labelMovementBasedMobileCommPositions: Label;
    labelPositionStatus: Label;
    labelR: Label;
    labelResendifnewstatusdatetimediffersby: Label;
    labelRuleGroups: Label;
    labelS: Label;
    labelSecondText: Label;
    labelTractorBased: Label;
    labelTrailerBasedMobileCommPositions: Label;
    layoutEventSchedule: TransmissionSchedule;
    panelAppointmentDate: Panel;
    panelCreatedAt: Panel;
    panelGeneral: Panel;
    panelGeneralInbound: Panel;
    panelGracePeriod: Panel;
    panelPositionText: Panel;
    panelRequireCheckboxes: Panel;
    panelResendCheckboxes: Panel;
    panelResendLabels: Panel;
    panelResendLeft: Panel;
    panelResendOptions: Panel;
    panelResendOptionsDetail: Panel;
    panelStatusRequired: Panel;
    sourceEdiDataRule: DataSource;
    sourceEdiReqdfldgroup: DataSource;
    sourceEdiRequiredField: DataSource;
    sourceEdistatuseventTable: DataSource;
    tabCreationRules: Tab;
    tabDataValidation: Tab;
    tabGeneral: Tab;
    tabSchedule: Tab;
    tableReqdFldGrp: Table;
    tableRequiredField: Table;
    tabsetStatusEdi: Tabset;
    textboxApptDateField: Textbox;
    textboxApptDateTable: Textbox;
    textboxBatchMethod: Textbox;
    textboxBatchMethodReadOnly: Textbox;
    textboxCallin: Textbox;
    textboxCreateMethod: Textbox;
    textboxDefaultDelayCode: Textbox;
    textboxDescr: Textbox;
    textboxEventType: Textbox;
    textboxGracePeriodHours: Textbox;
    textboxGracePeriodHoursResend: Textbox;
    textboxGracePeriodMinutes: Textbox;
    textboxGracePeriodMinutesResend: Textbox;
    textboxInStatusRequired: Textbox;
    textboxOrderHistory: Textbox;
    textboxPickupPosCreateHours: Textbox;
    textboxPickupPosCreateHoursResend: Textbox;
    textboxPickupPosCreateMinutes: Textbox;
    textboxPickupPosCreateMinutesResend: Textbox;
    textboxPickupPosStopOption: Textbox;
    textboxPostedType: Textbox;
    textboxReqSrc: Textbox;
    textboxReqSrcIn: Textbox;
    textboxResendEarlyGracePeriodHours: Textbox;
    textboxResendEarlyGracePeriodMinutes: Textbox;
    textboxResendLateGracePeriodHours: Textbox;
    textboxResendLateGracePeriodMinutes: Textbox;
    textboxStatusCode: Textbox;
    textboxStatusDateField: Textbox;
    textboxStatusDateFieldIn: Textbox;
    textboxStatusDateTable: Textbox;
    textboxStatusDateTableIn: Textbox;
    textboxStatusRequired: Textbox;
    textboxStopType: Textbox;
    textboxTimeRequired: Textbox;
    textboxUnDelayCrossRef: Textbox;
    textboxXmitSequence: Textbox;
}
